import { render } from "./bind_documents.html?vue&type=template&id=077cf649&external"
import script from "./bind_documents.js?vue&type=script&lang=js&external"
export * from "./bind_documents.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__